import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgSearch} from "~/assets/svg/search.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmSearchIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgSearch id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
